
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useTransactionEdit } from '@/modules/transaction/text/model/edit';
import { ROUTE_NAME_TRANSACTION } from '@/modules/transaction/router';

export default defineComponent({
    name: ROUTE_NAME_TRANSACTION.TEXT.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, fetch, update } = useTransactionEdit();

        onMounted(async () => {
            await fetch();
        });

        return { model, update };
    }
});
